/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'utcAsLocal',
    standalone: false
})
export class UtcAsLocalPipe implements PipeTransform {

    transform(utc: number): number {
        const utcMoment = moment.utc(utc);
        const utcYear = utcMoment.year();
        const utcMonth = utcMoment.month();
        const utcDay = utcMoment.date();

        const localMoment = moment([utcYear, utcMonth, utcDay]);

        return localMoment.valueOf();
    }

}
